import { render, staticRenderFns } from "./CalculatorFooter.vue?vue&type=template&id=f7b55068&scoped=true"
import script from "./CalculatorFooter.vue?vue&type=script&lang=js"
export * from "./CalculatorFooter.vue?vue&type=script&lang=js"
import style0 from "./CalculatorFooter.vue?vue&type=style&index=0&id=f7b55068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b55068",
  null
  
)

export default component.exports